module.exports = "<div>\n    <p >Dashboard</p>\n</div>\n"